import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { t, tLoc } from '../../i18n/translate.js';
import { listCountryWithoutVoice } from '../../services/appConstants/appConstants.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import Badge from '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import SortableList from '../../components/SortableList/SortableList.js';
import ContactItem from '../../components/Contacts/ContactItem.js';
import TopElement from '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import '../Rssi/RssiComponent.js';
import '../FirmwareUpgrade/FirmwareUpgrade.js';
import '../FirmwareUpgrade/FirmwareUpgradeConfirm.js';
import '../SessionController/SessionController.js';
import '../MagnetTest/TestMagnetComponent.js';
import '../AccessTokenPanel/AccessTokenPanel.js';
import '../LogoutModal/LogoutModal.module.scss.js';
import '../FirmwareUpgrade/logic/firmware.gql.js';
import 'lodash';
import '../billingAddress/BillingAddressForm.js';
import '../GuardInfo/LocationMap.js';
import '../GuardInfo/GuardAccessDirection.js';
import '../GuardInfo/GuardWaterDirection.js';
import '../RequestInstallationAddressChange/RequestInstallationAddressChange.js';
import '../CodeWordInput/CodeWordInput.js';
import '../CreateUser/UserForm/UserForm.js';
import '../CreateUser/AlarmContact/AlarmContact.js';
import '../CreateUser/AccessLevel/AccessLevel.js';
import '../EmergencyContactElement/EmergencyContactElementComponent.js';
import '../Alias/Alias.js';
import '../InstallationAddress/InstallationAddress.js';
import '../InstallationAddress/UpdatableInstallationAddress.js';
import '../ArmedStay/ArmedStayDeviceList.js';
import '../PhoneNumberForm/PhoneNumberForm.js';
import '../PinCode/PinCode.js';
import '../PinCode/SuccessPinCode.js';
import '../Alert/Alert.js';
import '../IntrusionVolume/IntrusionVolume.js';
import '../PetSettings/PetType.js';
import '../PetSettings/PetSettings.js';
import '../PetSettings/PetSettings.gql.js';
import '../PetSettings/PetWeight.js';
import '../TestTypeScript/PetWeight.module.scss.js';
import '../DevicesAdjustedForPets/DevicesAdjustedForPets.js';
import '../ArmDisarmPanel/ArmDisarmPanel.js';
import '../VoiceTest/VoiceTestComponent.js';
import '../MicroFrontendErrorBoundary/MicroFrontendErrorBoundary.js';
import '../ShippingAddressSelection/AddressSelectionItem.module.scss.js';
import styles from './EmergencyContactListComponent.module.scss.js';

var EmergencyContactListComponent = function EmergencyContactListComponent(_ref) {
  var users = _ref.users,
    voiceDevices = _ref.voiceDevices,
    gaTracking = _ref.gaTracking,
    sortDone = _ref.sortDone,
    isSaving = _ref.isSaving,
    dealer = _ref.dealer,
    mainPhone = _ref.mainPhone,
    secondaryPhone = _ref.secondaryPhone,
    showGoToUserText = _ref.showGoToUserText;
  var _useState = useState(users),
    _useState2 = _slicedToArray(_useState, 2),
    sortableUsers = _useState2[0],
    setSortableUsers = _useState2[1];
  var fixedPart = [];
  var count = 0;
  useEffect(function () {
    setSortableUsers(users);
  }, [users]);
  var renderItem = function renderItem(user, index) {
    return /*#__PURE__*/React.createElement(ContactItem, {
      title: user.name,
      description: user.mobilePhoneNumber,
      key: "drag-item-".concat(index),
      contactId: user.contactId
    });
  };
  if (!listCountryWithoutVoice.includes(dealer)) {
    if (voiceDevices.length > 0) {
      count += 1;
      var devType = voiceDevices.map(function (dev) {
        return t("MPLIB_GUI_LABEL_".concat(dev.gui.support));
      }).join(',');
      fixedPart.push( /*#__PURE__*/React.createElement(TopElement, {
        key: "a",
        title: t('MPLIB_SYSTEM_SETTINGS_VOICE_DEVICES'),
        popoverTxt: t('MPLIB_SYSTEM_SETTINGS_VOICE_DEVICES_DESC'),
        desc: devType,
        position: count
      }));
    }
    count += 1;
    fixedPart.push( /*#__PURE__*/React.createElement(TopElement, {
      key: "b",
      title: t('MPLIB_SYSTEM_SETTINGS_INTSALLATION_PHONE'),
      popoverTxt: t('MPLIB_SYSTEM_SETTINGS_INTSALLATION_PHONE_DESC'),
      desc: mainPhone,
      position: count
    }));
    if (secondaryPhone) {
      count += 1;
      fixedPart.push( /*#__PURE__*/React.createElement(TopElement, {
        key: "c",
        title: t('MPLIB_SYSTEM_SETTINGS_INTSALLATION_PHONE2'),
        popoverTxt: t('MPLIB_SYSTEM_SETTINGS_INTSALLATION_PHONE2_DESC'),
        desc: secondaryPhone,
        position: count
      }));
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.whiteBackground
  }, t('MPLIB_SYSTEM_SETTINGS_CONTACT_ORDER_DESC')), fixedPart, isSaving && /*#__PURE__*/React.createElement(LoadingSpinner, {
    centered: true,
    absolute: true,
    isLoading: true,
    size: "medium"
  }), /*#__PURE__*/React.createElement("section", {
    className: styles.users
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.countUser
  }, sortableUsers.map(function (u, i) {
    return /*#__PURE__*/React.createElement(Badge, {
      key: u.contactId,
      className: styles.badge,
      count: count + 1 + i
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.grow
  }, /*#__PURE__*/React.createElement(SortableList, {
    dataTestId: "operatorContactSortableList",
    sortableItems: sortableUsers.map(renderItem),
    sortDone: sortDone,
    gaTracking: gaTracking
  }))), /*#__PURE__*/React.createElement("article", {
    className: classNames('secondary', styles.center, styles.description)
  }, tLoc('MPLIB_SYSTEM_SETTINGS_CONTACT_ORDER_DRAG')), showGoToUserText && /*#__PURE__*/React.createElement("article", {
    className: classNames('secondary', styles.center, styles.description)
  }, tLoc('MPLIB_SYSTEM_SETTINGS_CONTACT_ORDER_ADD_REMOVE')));
};
EmergencyContactListComponent.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    mobilePhoneNumber: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    profile: PropTypes.string,
    callOrder: PropTypes.number
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  voiceDevices: PropTypes.array.isRequired,
  gaTracking: PropTypes.func,
  sortDone: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  dealer: PropTypes.string.isRequired,
  mainPhone: PropTypes.string,
  secondaryPhone: PropTypes.string,
  showGoToUserText: PropTypes.bool
};
EmergencyContactListComponent.defaultProps = {
  mainPhone: null,
  secondaryPhone: null,
  gaTracking: function gaTracking() {},
  showGoToUserText: true
};

export { EmergencyContactListComponent as default };
